module.exports = __webpack_public_path__ + "static/img/06_description.fc3e829.png";